import { inject, Component, Inject, TemplateRef, ViewChild, Input, ElementRef, AfterViewInit, OnDestroy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";


@Component({
  imports: [
    CommonModule,
    FormsModule,
  ],
  selector: 'LoginView',
  templateUrl: './LoginView.html',
  standalone: true,
  styleUrl: './LoginView.css'
})
export class LoginView implements AfterViewInit, OnDestroy {
  @ViewChild('myIframe', { static: false }) iframe!: ElementRef<HTMLIFrameElement>;

  constructor(private router: Router, private route: ActivatedRoute) { }

  private unlistenIframe: (() => void) | null = null;
  private url: string = '';

  ngAfterViewInit() {
    const iframeEl = this.iframe.nativeElement;

    // Wir müssen warten, bis das IFrame geladen ist
    iframeEl.addEventListener('load', () => {
      this.trackIframeUrl();
    });

    var url = this.route.snapshot.queryParamMap.get('qr');

    if (url)
      try {

        this.url = atob(url);

      } catch { }
  }

  trackIframeUrl() {
    try {
      const iframeWindow = this.iframe.nativeElement.contentWindow;

      if (!iframeWindow) return;

      // Event-Handler für URL-Änderungen im Iframe
      const handleUrlChange = () => {
        const currentUrl = iframeWindow.location.pathname;
        //console.log('Iframe URL hat sich geändert:', currentUrl);
        if (currentUrl == '/lgRet') {
          this.router.navigateByUrl(this.url);
        }
        // Hier dein Tracking-Code (z.B. Analytics-Service aufrufen)
      };

      handleUrlChange();

      iframeWindow.addEventListener('beforeunload', handleUrlChange);

      // Auf Events im Iframe lauschen
      iframeWindow.addEventListener('popstate', handleUrlChange);
      iframeWindow.addEventListener('hashchange', handleUrlChange);

      // Falls Klicks im Iframe die URL ändern (ohne echten Page-Reload)
      iframeWindow.addEventListener('click', () => {
        // Kleines Timeout, damit die URL sich vorher aktualisieren kann
        setTimeout(handleUrlChange, 50);
      });

      // Speicher die Funktion zum Aufräumen
      this.unlistenIframe = () => {
        iframeWindow.removeEventListener('popstate', handleUrlChange);
        iframeWindow.removeEventListener('hashchange', handleUrlChange);
      };

    } catch (error) {
      console.log('Zugriff auf Iframe verweigert (evtl. doch Cross-Origin?):', error);
    }
  }

  ngOnDestroy() {
    // Memory Leaks verhindern
    if (this.unlistenIframe) {
      this.unlistenIframe();
    }
  }
}
